(function() {
  'use strict';

  angular.module('eclipseApp.checkout').controller('CancelStepCtrl', [
    '$rootScope',
    '$scope',
    '$state',
    '$modalInstance',
    'data',
    '$http',
    'uteEndpoint',
    'buyService',
    'notifier',
    'brtSwitchCMS',
    '$window',
    'cartManager',
    function(
      $rootScope,
      $scope,
      $state,
      $modalInstance,
      data,
      $http,
      uteEndpoint,
      buyService,
      notifier,
      brtSwitchCMS,
      $window,
      cartManager
    ) {
      // if (buyService.getFulfillmentType() > 1 && buyService.getSession('profile').fulfillment.selectedOption === 'techInstall') {
      //   data.toState.name = 'techInstall';
      // }
      var currentCart = cartManager.internet.tierInCart();
      if (data.toState.name === 'home') {
        $scope.title = 'global.cta.cancel';
        $scope.okButtonLabel = 'global.cta.continue';
        $scope.message = 'global.message.goHomeOrStay';
      } else if (data.toState.name === 'cartSummary') {
        $scope.title = 'global.label.confirmCancellation';
        $scope.okButtonLabel = 'global.cta.yes';
        $scope.message = 'global.message.confirmCancellation';
      } else if (data.toState.name === 'techInstall') {
        $scope.title = 'global.label.techInstallChangeAppointment';
        $scope.okButtonLabel = 'global.cta.yes';
        $scope.message = 'global.message.techInstallConfirmChangeAppointment';
      } else if (data.toState.name === 'paymentOptions') {
        $scope.title = 'global.label.leavePaymentOptions';
        $scope.okButtonLabel = 'global.cta.yes';
        $scope.message = 'global.message.leavePaymentOptions';
      } else if (data.toState.name === 'internet') {
        $scope.title = 'global.label.editInternetPackage';
        $scope.okButtonLabel = 'global.cta.yes';
        $scope.message = 'global.message.editInternetPackage';
      } else {
        $scope.title = 'global.label.leavePage';
        $scope.okButtonLabel = 'global.cta.yes';
        $scope.message = 'global.message.leavePage';
      }

      // if Agent then cancel the flow when back button clicked
      if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
        $scope.okButtonLabel = 'global.cta.cancelOrder';
        $scope.title = 'global.label.cancelOrder';
        $scope.message = 'global.message.cancelOrder';
      }

      $scope.ok = function() {
        console.log('@CancelStepCtrl:data ', data);

        // only for anonymous customers we are extending the session.
        if (!($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent())) {
          var params = {
            userId: $rootScope.atg && $rootScope.atg.userId ? $rootScope.atg.userId.value : 'default',
            hashKey: $rootScope.atg && $rootScope.atg.hashKey ? $rootScope.atg.hashKey.value : 'default'
          };

          $http({
            method: 'POST',
            url: uteEndpoint('checkHeartBeat'),
            data: params
          }).error(function(res, status) {
            $modalInstance.close();
            switch (status) {
              case 500:
              case 5000:
              case 50000:
                notifier.notify.error({
                  errorCode: status
                });
                break;
              default:
                notifier.notify.error();
            }
          });
        }
        if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
          cartManager.cleanCart().then(function(res) {
            $window.sessionStorage.setItem('agentSelectedOffer', '{}');
            if (buyService.getSession('profile')) {
              buyService.cleanSessions();
            }
            $state.go('internet');
            buyService.resetStep('createUser');
          });
        }
        if ((data.toState.name === 'internet' || data.toState.name === 'cartSummary') && $state.is('review')) {
          {
            cartManager.addMeta({
              total: {
                grand: currentCart.selectedOffer.offerPrice.price,
                sub: currentCart.selectedOffer.offerPrice.price
              }
            });
          }
        }
        if (data.toState.name === 'techInstall' && data.isTechInstallTouched) {
          // @if
          // handle: edit techInstall
          // soft reset of fulfillment step
          buyService.resetStep('fulfillment');
        } else if (data.toState.name === 'cartSummary' || data.toState.name === 'internet') {
          // @elseif
          // handle: edit package

          // @param true
          // force reset to default fulfillment state
          buyService.resetStep('fulfillment', true);
        }

        // @var forceTransition : Bool
        // if true => allows transition to another state
        // if false => prevents transitioning

        if (data.toState && !data.getForceTransition()) {
          // console.log('@CancelStepCtrl:@getForceTransition():value:BEFORE', data.getForceTransition());
          data.setForceTransition(true);
          // console.log('@CancelStepCtrl:@getForceTransition():value:AFTER', data.getForceTransition());
        }

        // check if techInstall was selected previously before cancelling
        // call cancelAppointment if so before going to cart-summary page
        if (data.isTechInstallTouched) {
          buyService
            .cancelCheckout()

            .then(
              function(res) {
                // console.log('@CancelStepCtrl:buyService.cancelCheckout().success:data', data);
                // $state.go(data.toState);
              },
              function(data) {
                _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                _satellite.track('bfa-fhsi-error');
                notifier.notify.error();
              }
            )
            .finally(function() {
              $modalInstance.close(data.toState);
            });
        } else if ($state.is('createUser') || $state.is('creditCheck')) {
          // console.log('@CancelStepCtrl:elseif:$state.create || $state.creditCheck');

          buyService.deleteSession('profile');
          $modalInstance.close(data.toState);

          // $state.go(data.toState);
        } else {
          // go straight to cart summary if techInstall was not selected
          // $state.go(data.toState, {strict: false});
          $modalInstance.close(data.toState);
        }
      };

      $scope.cancel = function() {
        $modalInstance.dismiss();
      };
    }
  ]);
})();
